export const paths = {
  home: '/',
  newReport: '/relatorios/novo',
  reports: '/relatorios',
  report: (id: string) => `/relatorios/${id}`,
  inspection: (id: string) => `/relatorios/${id}/inspecao`,
  reportSummary: (id: string) => `/relatorios/${id}/resumo`,
  clients: '/clientes',
  newClient: '/clientes/novo',
  client: (id: string) => `/clientes/${id}`,
  editClient: (id: string) => `/clientes/${id}/editar`,
  machines: '/maquinas',
  newMachine: '/maquinas/nova',
  machine: (id: string) => `/maquinas/${id}`,
  editMachine: (id: string) => `/maquinas/${id}/editar`,
  technicians: '/tecnicos',
  newTechnician: '/tecnicos/novo',
  technician: (id: string) => `/tecnicos/${id}`,
  editTechnician: (id: string) => `/tecnicos/${id}/editar`,
  backup: '/backup',
  settings: '/configuracoes',
} as const
